module.exports = __webpack_public_path__ + "img/banner03.836d31e4.jpg";